<ion-app>
  <ion-split-pane contentId="main-content" when="false">
    @if (token) {
    <app-sidemenu></app-sidemenu>
    }
    <div class="ion-page" id="main-content">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>
</ion-app>